import { CONTACT } from "@/data/content";
import { MessageCircle } from "lucide-react";

export const WhatsAppButton = () => {
  const wa = `https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent("Hi Risi Wellness, I'd like to enquire about a treatment.")}`;
  return (
    <a
      href={wa}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-40 flex items-center gap-2 rounded-full bg-[#25D366] text-white pl-4 pr-5 py-3 shadow-lg hover:scale-105 transition-transform"
    >
      <MessageCircle size={22} />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );
};
